import { render, staticRenderFns } from "./smart.vue?vue&type=template&id=bb6a12dc&scoped=true"
import script from "./smart.vue?vue&type=script&lang=js"
export * from "./smart.vue?vue&type=script&lang=js"
import style0 from "./smart.vue?vue&type=style&index=0&id=bb6a12dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6a12dc",
  null
  
)

export default component.exports